import React from 'react';
import { Button } from '../../../../components';
import EditIcon from '@mui/icons-material/Edit';

interface SipProviderActionsProps {
  onEdit: () => void;
  loading?: boolean;
}

export const SipProviderActions: React.FC<SipProviderActionsProps> = ({
  onEdit,
  loading = false,
}) => {
  return (
    <div className="flex items-center justify-end gap-2">
      <Button
        onClick={onEdit}
        size="small"
        className="px-2"
        disabled={loading}
        type="contrast"
        icon={<EditIcon className="h-8 w-8 text-buttonPrimary" />}
      />
    </div>
  );
};
